import { useTranslation } from "react-i18next";
import { useCloneToolDraft } from "../../hooks/useTools";
import { useDoesToolHaveDraft } from "../../hooks/useTools";
import { useNavigate } from "react-router-dom";
import { ClientRoutes } from "../../models/ClientRoutes";
import { ButtonWithLoading } from "../ButtonWithLoading";
import { Button } from "@fluentui/react-components";
import { CreateCloneToolRequest } from "../../models/Tool";

interface CreateToolDraftButtonProps {
  toolId: string;
  versionId: string;
  oldVersion: boolean;
}
export const CreateToolDraftButton = (props: CreateToolDraftButtonProps) => {
  const { toolId, versionId, oldVersion } = props;
  const { data: draftId, isLoading: loadingHasDraft } = useDoesToolHaveDraft(
    toolId ? toolId : ""
  );

  const { mutateAsync: createToolDraft, isPending: createDraftPending } =
    useCloneToolDraft(toolId);

  const { t } = useTranslation();

  const navigate = useNavigate();

  if (loadingHasDraft) {
    return <></>;
  }

  const onCreateDraftClick = async () => {
    if (!versionId) {
      return;
    }
    const createdDraftRequest: CreateCloneToolRequest = {
      versionId: versionId,
      oldVersion: oldVersion,
    };

    const createdDraftTool = await createToolDraft(createdDraftRequest);
    navigate(`${ClientRoutes.ToolsDrafts}/${createdDraftTool.versionId}`);
  };

  const navigateToDraft = () => {
    if (!draftId) {
      return;
    }

    navigate(`${ClientRoutes.ToolsDrafts}/${draftId}`);
  };

  return draftId ? (
    <Button onClick={navigateToDraft}>{t("toDraft")}</Button>
  ) : (
    <ButtonWithLoading
      onClick={onCreateDraftClick}
      isLoading={createDraftPending}
      text={t("edit")}
      disabled={!toolId}
    />
  );
};

export default CreateToolDraftButton;
